import Button, { type ButtonProps } from "../../../core/button/Button";

export const AddButton = ({
  onClick,
  leadingIcon = "plus-md",
  variant,
  ...props
}: { show?: boolean } & React.HTMLAttributes<HTMLDivElement> & ButtonProps) => {
  if (props.show === false) return null;
  return (
    <div {...props}>
      <Button
        leadingIcon={leadingIcon}
        size="md"
        variant={variant}
        onClick={onClick}
        {...props}
      />
    </div>
  );
};
